module.exports = __webpack_public_path__ + "static/media/edit-3.cb7144cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/edit-3.svg
// module id = 1392
// module chunks = 0